"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _EDSContext = require("../EDSContext/EDSContext");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["edsContext"];
var withPlatform = function withPlatform() {
  return function (WebComponent, MobileComponent) {
    var Wrap = function Wrap(props) {
      var edsContext = props.edsContext,
        rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, edsContext.platform === 'mobile' && /*#__PURE__*/_react.default.createElement(MobileComponent, rest), (!edsContext.platform || edsContext.platform === 'web') && /*#__PURE__*/_react.default.createElement(WebComponent, rest));
    };
    Wrap.displayName = 'withPlatformWrap';
    Wrap.propTypes = {
      edsContext: _propTypes.default.object
    };
    return (0, _EDSContext.withEDSContext)(Wrap);
  };
};
var _default = exports.default = withPlatform;